import { Flex } from '@chakra-ui/react';
import {
  ListingComparableSetFragment,
  MlsListingFragment,
} from '@client/graphql/__generated__/types';
import { ComparableState } from '~/apps/consumer/pages/ListingSetup/Comparables/ComparablesPage';
import { ViewCompsColumns } from './ViewCompsColumns';

export const PrintCompColumns = ({
  mainMlsListing,
  comparableSet,
  comps,
}: {
  mainMlsListing: MlsListingFragment;
  comparableSet?: ListingComparableSetFragment;
  comps: ComparableState[];
}) => {
  // Split comps into groups of 4
  const compGroups: ComparableState[][] = [];
  for (let i = 0; i < comps.length; i += 4) {
    compGroups.push(comps.slice(i, i + 4));
  }

  return (
    <Flex flexDirection="column" width="100%">
      {compGroups.map((compGroup, groupIndex) => (
        <ViewCompsColumns
          key={groupIndex}
          isForPdf
          isPrint
          comparableSet={comparableSet}
          comps={compGroup}
          mainMlsListing={mainMlsListing}
        />
      ))}
    </Flex>
  );
};
